import { useEffect, useRef, useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useLogout from '../../../helpers/useLogout';
import { setAccessToken, setCognitoUser } from '../../../state/auth/actions';
import { Auth } from 'aws-amplify';

const useAuthListener = () => {
  const cognitoUser = useSelector((state) => state.auth.cognitoUser);
  const location = useLocation();
  const { logout } = useLogout();

  const accessTokenExpiration =
    cognitoUser?.signInUserSession?.accessToken?.payload?.exp;

  const isFirstRender = useRef(true);

  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  const getAuthenticatedUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();

      if (user) {
        user.refreshSession(currentSession.refreshToken, (err, session) => {
          batch(() => {
            dispatch(setAccessToken(session.accessToken.jwtToken));
            dispatch(setCognitoUser(user));
          });

          setLoading(false);
        });
      } else {
        logout();
      }
    } catch (err) {
      logout();
      setLoading(false);
    }
  };

  useEffect(() => {
    async function checkAuth() {
      await getAuthenticatedUser();
    }

    if (isFirstRender.current) {
      isFirstRender.current = false;
      checkAuth();
    }
  }, []);

  useEffect(() => {
    if (isFirstRender.current || loading || !accessTokenExpiration) {
      return;
    }

    const accessTokenValid =
      accessTokenExpiration && accessTokenExpiration > Date.now() / 1000;

    if (!accessTokenValid) {
      window.location.reload();
    }
  }, [location, loading, accessTokenExpiration]);

  return {
    authLoading: loading,
  };
};

export default useAuthListener;
